export const fetch = {
  pathname: ({ id }) => `/collections/${id}`,
  headers: (headers, { vtApiKey }) => headers.set('X-ApiKey', vtApiKey)
}

export const owner = {
  pathname: ({ id }) => `/collections/${id}/owner`,
  headers: (headers, { vtApiKey }) => headers.set('X-ApiKey', vtApiKey)
}

export const fetchGraphId = {
  pathname: ({ id }) => `/collections/${id}/autogenerated_graphs`,
  headers: (headers, { vtApiKey }) => headers.set('X-ApiKey', vtApiKey)
}
